class trackerSignup extends HTMLElement {
    constructor() {
      super();
      this.popup = this.querySelector("#signup_popup");
      this.closeButton = this.querySelector(".signup-popup--close svg");
      this.emailInput = this.querySelector('.subscribe-email--input');
      this.messageElement = this.querySelector('.newsletter-form__message--subscribe');
      this.signupContent = this.querySelectorAll(".signup-content");
      this.windowUrl = window.location.href;
      this.tracker = this.querySelector(".tracker");
      this.init();
    }
  
    init() {
    this.tracker.addEventListener('click', (event)=> {
        event.preventDefault(); 
        this.showPopup();
    });
      this.addEventListeners();
    }

  
    showPopup() {
      this.popup.style.display = "block";
      sessionStorage.setItem("signuptracker", "true");
    }
  
    removePopup() {
      this.popup.style.display = "none";
      sessionStorage.setItem("signuptracker", "false");

      let url = new URL(this.windowUrl);

      if(url.search || url.hash){
          url.search = '';  
          url.hash = '';
          window.history.replaceState({}, document.title, url.toString());
          window.location.reload();
      }

    }
  
    addEventListeners() {
      this.closeButton.addEventListener("click", () => {
        this.closePopup();
      });
  
      this.popup.addEventListener("click", (event) => {
        if (event.target === this.popup) {
          this.closePopup();
        }
      });
    }
  
    closePopup() {
      this.removePopup();
    }
  
    connectedCallback() {
      this.alredysubscribedValidation = this.windowUrl.includes('form_type=customer');
      if (this.alredysubscribedValidation && this.emailInput && this.emailInput.value.length!== 0) {
        this.emailInput.value = "";
        this.messageElement.classList.remove('hidden');
        this.signupContent.forEach(content=>content.classList.add('hidden'));
        sessionStorage.setItem("signupPopupShown", "true");
      } else if (this.messageElement) {
        this.messageElement.classList.add('hidden');
      }
      this.subscribed = this.windowUrl.includes('customer_posted=true');
      if(this.alredysubscribedValidation || this.subscribed && sessionStorage.getItem("signuptracker") === "true"){
        this.showPopup();
        window.open(this.tracker.href, '_blank');
      }
    }
  }
  
customElements.define("tracker-signup", trackerSignup);